// features/plans/data/plansData.ts
export const plansData = {
  keyword: {
    subtitle:
      "Monitors mentions from social media platforms based on main, additional, and excluded keywords.",
    cards: [
      {
        title: "Starter",
        price: "$676/mo",
        included: [
          "Keyword monitoring up to 50,000 total quota",
          "Rate limit: 100 calls/min",
        ],
        hasFreeTrial: false,
        popular: true,
      },

      {
        title: "Basic",
        price: "$1,361/mo",
        included: [
          "Keyword monitoring up to 500,000 total quota",
          "Rate limit: 100 calls/min",
        ],
      },
      {
        title: "Plus",
        price: "$2,046/mo",
        included: [
          "Keyword monitoring up to 1,000,000 total quota",
          "Rate limit: 200 calls/min",
        ],
      },
      {
        title: "Premium",
        price: "$4,015/mo",
        included: [
          "Keyword monitoring up to 5,000,000 total quota",
          "Rate limit: 300 calls/min",
        ],
      },
      {
        title: "Enterprise",
        price: "$5,812/mo",
        included: [
          "Keyword monitoring up to 10,000,000 total quota",
          "Rate limit: 500 calls/min",
        ],
      },
    ],
  },
  influencer: {
    subtitle:
      "Monitor specific channels (pages, influencer etc.) and receive all posts without using keywords.",
    cards: [
      {
        title: "Starter",
        price: "$676/mo",
        included: [
          "Monitor up to 100 influencer channels",
          "Rate limit: 50 calls/min",
        ],
        hasFreeTrial: false,
        popular: true,
      },
      {
        title: "Basic",
        price: "$1,361/mo",
        included: [
          "Monitor up to 500 influencer channels",
          "Rate limit: 100 calls/min",
        ],
      },
      {
        title: "Plus",
        price: "$2,046/mo",
        included: [
          "Monitor up to 1,000 influencer channels",
          "Rate limit: 200 calls/min",
        ],
      },
      {
        title: "Premium",
        price: "$4,015/mo",
        included: [
          "Monitor up to 5,000 influencer channels",
          "Rate limit: 300 calls/min",
        ],
      },
      {
        title: "Enterprise",
        price: "$5,812/mo",
        included: [
          "Monitor up to 10,000 influencer channels",
          "Rate limit: 500 calls/min",
        ],
      },
    ],
  },
  source: {
    subtitle:
      "Make live updates of posts to obtain the latest engagement scores, author details, etc.",
    cards: [
      {
        title: "Usage Based",
        price: "$100 - Tier 1",
        included: ["Usage based pricing", "Rate limit: 50 calls/min"],
        hasFreeTrial: false,
        popular: true,
      },
    ],
  },
  pulse: {
    subtitle:
      "Monitors mentions from social media platforms based on main, additional, and excluded keywords.",
    cards: [
      {
        title: "Starter",
        price: "$676/mo",
        included: [
          "Monitor up to 100 influencer channels",
          "Rate limit: 50 calls/min",
          "Monitoring 1 platform",
        ],
        hasFreeTrial: false,
        popular: true,
      },
      {
        title: "Basic",
        price: "$1,361/mo",
        included: [
          "Keyword monitoring up to 500,000 total quota",
          "Rate limit: 100 calls/min",
          "Monitoring 1 platform",
        ],
      },
      {
        title: "Plus",
        price: "$2,046/mo",
        included: [
          "Keyword monitoring up to 1,000,000 total quota",
          "Rate limit: 200 calls/min",
          "Monitoring 1 platform",
        ],
      },
      {
        title: "Premium",
        price: "$4,015/mo",
        included: [
          "Keyword monitoring up to 5,000,000 total quota",
          "Rate limit: 300 calls/min",
          "Monitoring 1 platform",
        ],
      },
      {
        title: "Enterprise",
        price: "$5,812/mo",
        included: [
          "Keyword monitoring up to 10,000,000 total quota",
          "Rate limit: 500 calls/min",
          "Monitoring 1 platform",
        ],
      },
    ],
  },
};
